import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Params, Router } from '@angular/router';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { role } from '../../constants/role-enum';
import { ROUTE_URL } from '../../constants/route-constants';
import { SessionService } from '../../session-service/session.service';
import { TopNavigationService } from '../top-navbar/top-nav.service';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { HeaderActiveRoute, HeaderActiveRouteService } from './active-route.service';
import { map, take } from 'rxjs/operators';
import { ImpersonationService, CLIENT_MANAGER_PARAM } from '../../impersonation/impersonation.service';
import { environment } from 'src/environments/environment';
import { SurveyListService } from 'src/app/survey-insight/survey-list/survey-list.service';

@Component({
    selector: 'top-navbar-center',
    templateUrl: './top-navbar-center.component.html',
    styleUrls: ['./top-navbar-center.component.scss']
})

export class TopNavBarCenterComponent implements OnInit, OnDestroy {
    isClientManagerView = false;
    isImpersonatingClientManager = false;
    engagementId = this.getEngagementId();
    clientId = this.getClientId();
    public ROUTE_URLs = ROUTE_URL;
    userDetails: UserDetails;
    isSmeView = false;
    isHomeScreen = false;
    constructor(
        public sessionService: SessionService,
        public topNavigationService: TopNavigationService,
        private _router: Router,
        private _userDataService: UserDataService,
        private activeRouteService: HeaderActiveRouteService,
        private impersonationService: ImpersonationService,
        private _surveyListService: SurveyListService
    ) { }

    isNavigatorActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Navigator)
    );

    isDataImportActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.DataImport)
    );

    isSurveysActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Surveys)
    );

    isInterviewsActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Interviews)
    );

    isReportsActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Reports)
    );

    isDocumentsActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Documents)
    );

    isInsightsActive$ = this.activeRouteService.activeHeaderRoute$.pipe(
        map((route) => route === HeaderActiveRoute.Insights)
    );



    private destroyed$ = new Subject<void>();

    ngOnInit(): void {
        this._userDataService.userDetails$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe(userdetails => {
            if (userdetails) {
                this.userDetails = userdetails;
            }
        });

        combineLatest([
            this.impersonationService.clientManagerModeActive$,
            this.impersonationService.smeUserDetails$,
        ]).pipe(
            takeUntil(this.destroyed$)
        ).subscribe(([clientManagerActive, userDetails]) => {
            this.isImpersonatingClientManager = clientManagerActive;
            if (userDetails || (this.userDetails && this.userDetails.roleId === role.respondent)) {
                this.isSmeView = true;
                this.topNavigationService.setStudyNav(false);
            } else if (clientManagerActive || (this.userDetails && this.userDetails.roleId === role.clientManager)) {
                this.isSmeView = false;
                this.homeScreenStatus ? this.topNavigationService.setStudyNav(false) : this.topNavigationService.setStudyNav(true);
                this.topNavigationService.setIsClientUser(false);
                this.topNavigationService.setIsClientManager(true);
            } else {
                this.homeScreenStatus ? this.topNavigationService.setStudyNav(false) : this.topNavigationService.setStudyNav(true);
                this.topNavigationService.setIsClientUser(false);
                this.topNavigationService.setIsClientManager(false);
            }
        });
    }

    getEngagementId() {
        return this.sessionService.getSession('engagementId');
    }

    getClientId() {
        return this.sessionService.getSession('clientId');
    }

    navigateByEngId(route) {
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate([route(this.getEngagementId())], this.getNavigationExtras()); 
        });
    }

    goToReconciliationPage() {
        combineLatest([
          this.impersonationService.clientManagerModeActive$,
          this.impersonationService.smeUserDetails$,
        ]).pipe(take(1))
          .subscribe(([isClientManagerMode, smeDetails]) => {
            this._surveyListService.goToReconciliationPage(isClientManagerMode, smeDetails, +this.getEngagementId(), +this.getClientId());
        });
      }

    getNavigationExtras(): NavigationExtras {
        var extras: NavigationExtras = this.topNavigationService.getIsClientManager() && this.isImpersonatingClientManager
            ? { queryParams: { viewAs: CLIENT_MANAGER_PARAM },
                queryParamsHandling: 'merge' }
            : { queryParamsHandling: 'preserve' }
        return extras;
    }

    openTimeTacking(route) {
        this.sessionService.setSession('isOpenTimeTrackFromLandingPage', 'true');
        this.navigateByEngId(route);
    }

    getNavigatorRouterLink() {
        return this.ROUTE_URLs.STUDYHOME(this.getEngagementId())
    }

    getInterviewRouterLink() {
        return this.ROUTE_URLs.INTERVIEWS(this.getEngagementId())
    }

    homeScreenStatus(): boolean {
        this._router.events.subscribe(event => {

            if (window.location.pathname.indexOf('/home') > -1) {
                this.isHomeScreen = true;
            } else {
                this.isHomeScreen = false;
            }
        });
        return this.isHomeScreen;
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
